module.exports = __webpack_public_path__ + "static/img/video.f3a2e5c1.png";